const getOptions = (email, isTrade) => {
    return {
        method: 'POST',
        headers: {
            /*'Content-Type': 'application/json',
            revision: '2023-12-15',*/
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: 'subscription',
                attributes: {
                    custom_source: 'Sign Up Website Form',
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: email,
                                properties: {
                                    /*'$source': 'Revision Updated Sign Up',*/
                                    'Is Trade': isTrade
                                }
                            }
                        }
                    }
                },
                relationships: { list: { data: { type: 'list', id: 'RBHQVD' } } }
            }
        })
    };
}

function subscribe() {
    const options = getOptions(arguments[0], arguments[1])
    //console.log(options)
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Vhrxtu', options)
        .then(response => {
            //just check the status
            if (response.status === 202) {
                //console.log("subscription done")
                return true
            }
            else {
                //console.log("subscription failed")
                return false
            }
        })
        .catch(error => {
            console.error(error)
            return false
        })
}

function signupError(show) {
    if (show === true && errorDiv.classList.contains('d-none')) {
        errorDiv.classList.remove('d-none')
        errorDiv.focus()
    }
    else if (show === false && errorDiv.classList.contains('d-none') === false) {
        errorDiv.classList.add('d-none')
    }
}

function buttonLoading(show) {
    if (show === true) {
        signUpButton.querySelector('span').classList.add('d-none')
        //signUpButton.querySelector('.signup-loader').classList.remove('d-none')
        signUpButton.querySelector('.signup-loader').style = "display:block;"
    }
    else {
        //signUpButton.querySelector('.signup-loader').classList.add('d-none')
        signUpButton.querySelector('.signup-loader').style = "display:none;"
        signUpButton.querySelector('span').classList.remove('d-none')

    }
}

//find a way to store customer details if they are logged in.
const signUpButton = document.querySelector(".signup-button")
const form = document.querySelector(".signup-form")
const successDiv = document.querySelector(".success-message")
const errorDiv = document.querySelector('.signup-error')

form.addEventListener("submit", async (e) => {
    //don't reload the page
    e.preventDefault()
    //console.log("form submitting.")

    //remove signupError if exists
    signupError(false)
    //start button loader animation
    buttonLoading(true)

    //get form values
    const email = document.querySelector(".signup-input").value
    const isTrade = document.querySelector('input[name="client_type"]:checked').value;
    //if user logged in, a hidden input area for address is created which script can access.


    //do requests
    const result = await subscribe(email, isTrade)

    //if successful
    if (result === true) {
        form.classList.add("d-none")
        successDiv.classList.remove("d-none")
        successDiv.setAttribute('role', 'alert')
        successDiv.setAttribute('aria-live', 'assertive')
        successDiv.focus()
    }
    else {
        //show error div
        signupError(true)
    }
    //stop button loader animation
    buttonLoading(false)
})
